import { ReactNode } from 'react';
import { useLoadConfiguration, useConfigurationStorage } from '@data';
import { AppLoader } from '@components';

type ConfigurationGateProps = {
  children: ReactNode;
};

export const ConfigurationGate = ({ children }: ConfigurationGateProps) => {
  const { isError } = useLoadConfiguration();
  const { configuration } = useConfigurationStorage();

  // Show the app loader until the configuration is loaded, either from the cache or the API.
  // If the fetch failed, render the app anyway.
  if (!configuration && !isError) {
    return <AppLoader />;
  }

  return <>{children}</>;
};
